export default "__VITE_ASSET__CNQQmtDb__"